<div class="custom confirmation">
  <div class="modal-body">
    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="cancel()"></button>

    <div class="confirmation__content">
      <span *ngIf="icon" class="confirmation__icon" [ngClass]="'confirmation__icon--' + tone">
        <i class="mdi" [ngClass]="icon"></i>
      </span>

      <div class="confirmation__text">
        <div class="confirmation__title">{{ title | transloco }}</div>
        <div *ngIf="message" class="confirmation__message">{{ message | transloco }}</div>
      </div>
    </div>
  </div>

  <div class="modal-footer two-actions confirmation__actions">
    <button type="button" class="btn btn-outline" (click)="cancel()">{{ cancelBtnText | transloco }}</button>
    <button type="button" class="btn btn-main" [ngClass]="'btn-main--' + tone" (click)="confirm()">
      {{ confirmBtnText | transloco }}
    </button>
  </div>
</div>
